import Proxy from './Proxy';

class OverviewProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/store/overview', parameters);
  }

}

export default OverviewProxy;
